"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _url = _interopRequireDefault(require("url"));
// shuffle 模式下，url 会根据 getStaticFile 的调用次数
// 来返回是否被替换
var shuffleFlip = true;
var getStaticFile = function getStaticFile(url, opts) {
  if (typeof opts === 'string') {
    var _urlObj = _url["default"].parse(url);
    _urlObj.host = opts.replace('//', '');
    return _url["default"].format(_urlObj);
  }
  var shuffle = opts.shuffle,
    host = opts.host;
  var urlObj = _url["default"].parse(url);
  if (!shuffle || shuffleFlip) {
    shuffleFlip = !shuffleFlip;
    urlObj.host = host.replace('//', '');
    return _url["default"].format(urlObj);
  }
  shuffleFlip = !shuffleFlip;
  return url;
};
var _default = exports["default"] = getStaticFile;